// @ts-ignore
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export const CustomerDocument = gql `
    query Customer {
  customer {
    id
    displayName
    email
    club {
      active
      onFreeTrial
      freeTrialEligible
    }
    membership {
      id
      linked
      doubleSubscription
      eligibleForMigration
      subscription {
        active
        activeDaysRemaining
        autoRenewing
        freeTrialEligible
        interval
        latestMembershipPeriodEnd
        onFreeTrial
        purchasePrice
        freeTrialDaysRemaining
        isTeamMember
      }
    }
    storeCredit {
      credit {
        amount
      }
      expiry
    }
    metaData {
      customerUuid
    }
  }
}
    `;
/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions) {
    return Apollo.useQuery(CustomerDocument, baseOptions);
}
export function useCustomerLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(CustomerDocument, baseOptions);
}
